/**
 * `/klienci/zgloszenia/$leadId` — one lead. The parameter is parsed here, and `null` reaches the
 * screen as an unusable address rather than as a request that could only 404.
 */

import { createFileRoute, useParams } from '@tanstack/react-router';

import { LeadDetailScreen } from '~/pages/public-form-leads';

export const Route = createFileRoute('/_shell/klienci/zgloszenia/$leadId')({
  component: LeadDetailRoute,
});

function LeadDetailRoute() {
  const { leadId } = useParams({ from: '/_shell/klienci/zgloszenia/$leadId' });
  const id = Number(leadId);
  return <LeadDetailScreen leadId={Number.isInteger(id) && id > 0 ? id : null} />;
}
